import thunk from './thunk'

export default [
    thunk
]